<template>
    <Card :title="$t('labels.marketplaces')">
        <div class="card-body">
            <div class="row">
                <div class="col-4">
                    <FormGroup :label="$t('labels.approve_order_statuses')">
                        <AppMultiselect
                            v-model="approveOrderStatuses"
                            :options="approveOrderOptions"
                        />
                    </FormGroup>
                </div>
                <div class="col-4">
                    <FormGroup :label="$t('labels.set_delivery_number_statuses')">
                        <AppMultiselect
                            v-model="setDeliveryNumberStatuses"
                            :options="setDeliveryNumberOptions"
                        />
                    </FormGroup>
                </div>
                <div class="col-4">
                    <FormGroup :label="$t('labels.decline_order_statuses')">
                        <AppMultiselect
                            v-model="declineOrderStatuses"
                            :options="declineOrderOptions"
                        />
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton color="indigo" @click="save">
                <i class="icon-floppy-disk mr-2"></i>
                {{ $t('buttons.save') }}
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../../components/new/CardComponent.vue";
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import AppMultiselect from "../../../../../components/new/form/autocomplete/AppMultiselect.vue";
import AppButton from "../../../../../components/new/button/AppButton.vue";

import { httpClient } from "../../../../../services/HttpClient";
import MessageNotificator from "../../../../../services/MessageNotificator";
import { OrderStatusMarketplaceActionEnum } from "../../../../enums/OrderStatusMarketplaceActionEnum";

export default {
    name: "MarketplaceCard",
    components: {
        Card, FormGroup, AppMultiselect, AppButton
    },
    data() {
        return {
            statuses: [],
            approveOrderStatuses: [],
            setDeliveryNumberStatuses: [],
            declineOrderStatuses: []
        }
    },
    computed: {
        approveOrderOptions() {
            return this.availableStatuses(this.setDeliveryNumberStatuses, this.declineOrderStatuses);
        },
        setDeliveryNumberOptions() {
            return this.availableStatuses(this.approveOrderStatuses, this.declineOrderStatuses);
        },
        declineOrderOptions() {
            return this.availableStatuses(this.approveOrderStatuses, this.setDeliveryNumberStatuses);
        }
    },
    methods: {
        availableStatuses(...excludedStatusGroups) {
            const excludedUuids = new Set(excludedStatusGroups.flat().map(status => status.uuid));

            return this.statuses.filter(status => !excludedUuids.has(status.uuid));
        },
        fetchCrmStatuses() {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/statuses`, {
                orders: [{ column: 'priority_order', dir: 'asc' }],
                limit: 100
            })
            .then(response => {
                this.statuses = response.data.data;
                this.approveOrderStatuses = this.statuses.filter(status => status.action_on_marketplace === OrderStatusMarketplaceActionEnum.APPROVE_ORDER);
                this.setDeliveryNumberStatuses = this.statuses.filter(status => status.action_on_marketplace === OrderStatusMarketplaceActionEnum.SET_DELIVERY_NUMBER);
                this.declineOrderStatuses = this.statuses.filter(status => status.action_on_marketplace === OrderStatusMarketplaceActionEnum.DECLINE_ORDER);
            });
        },
        actionOnMarketplaceFor(status) {
            if (this.approveOrderStatuses.some(item => item.uuid === status.uuid)) {
                return OrderStatusMarketplaceActionEnum.APPROVE_ORDER;
            }

            if (this.setDeliveryNumberStatuses.some(item => item.uuid === status.uuid)) {
                return OrderStatusMarketplaceActionEnum.SET_DELIVERY_NUMBER;
            }

            if (this.declineOrderStatuses.some(item => item.uuid === status.uuid)) {
                return OrderStatusMarketplaceActionEnum.DECLINE_ORDER;
            }

            return null;
        },
        async save() {
            const requests = this.statuses.map(status => httpClient.patch(`/projects/${this.$route.params.projectUuid}/crm/statuses/${status.uuid}`, {
                action_on_marketplace: this.actionOnMarketplaceFor(status)
            }));

            await Promise.all(requests).then(() => {
                new MessageNotificator().success(this.$t('alerts.success'));
            });
        }
    },
    created() {
        this.fetchCrmStatuses();
    }
}
</script>
